import axiosInstance from '../../axios-config';

const auditLogApi = '/api/users/{0}/audit';
const postLogoffUrl = '/api/users/{0}/audit/logoff';

export const audit = (type, userId, patientId, extraParameters) => {
  let parameters = {};
  if (extraParameters !== null && extraParameters !== undefined) {
    parameters = extraParameters;
  }
  parameters.auditEventType = type;
  parameters.patientId = patientId;

  // TODO: handle userId is null
  return axiosInstance.post(
    auditLogApi.replace('{0}', userId), parameters);
};

export const logoffAudit = (type, userId, patientId) => {
  const parameters = {};
  parameters.auditEventType = type;
  if (patientId) {
    parameters.patientId = patientId;
  }

  // TODO: handle userId is null
  return axiosInstance.post(
    postLogoffUrl.replace('{0}', userId), parameters);
};